import { ArticleHeading1, ArticleParagraph1, LinkButton } from '@cian/ui-kit';
import * as React from 'react';

import * as styles from './BuildersProjectsBanner.css';
import { Container } from '../Container';

export const BuildersProjectsBanner = () => {
  return (
    <Container className={styles['container']} dataName="BuildersProjectsBanner">
      <div className={styles['inner']}>
        <div className={styles['content']}>
          <div className={styles['title']}>
            <ArticleHeading1>Проекты домов для любого участка</ArticleHeading1>
          </div>
          <div className={styles['description']}>
            <ArticleParagraph1>
              Большой выбор материалов и видов домов от надёжных строительных компаний
            </ArticleParagraph1>
          </div>
          <LinkButton
            size="M"
            theme="fill_primary"
            href="/country-builders-projects/?utm_medium=zagorod&utm_content=banner"
            target="_blank"
          >
            Посмотреть все
          </LinkButton>
        </div>
        <div className={styles['image']} />
      </div>
    </Container>
  );
};
